import { ChartType, Plugin } from 'chart.js'
import { getTheme } from 'themes'

type DrawLineOnHoverOpts = {
  /** draw a vertical line at the hovered x position */
  axis?: 'x' | 'y' // default: 'x'
  color?: string
  dash?: number[]
  disabled?: boolean
  width?: number
}

export const drawLineOnHover: Plugin<ChartType, DrawLineOnHoverOpts> = {
  id: 'drawLineOnHover',
  beforeDatasetsDraw(chart, _args, opts) {
    if (opts.disabled) return

    const theme = getTheme('light')

    const tooltip: any = chart.tooltip
    const active = tooltip?.getActiveElements?.()?.[0]

    if (!active) return

    const meta = chart.getDatasetMeta(active.datasetIndex)
    const el: any = meta?.data?.[active.index]

    const axis = opts?.axis ?? 'x'
    const { top, bottom, left, right } = chart.chartArea
    const ctx = chart.ctx

    let pos: number | undefined

    if (el && typeof el[axis] === 'number') {
      pos = el[axis]
    } else {
      const indexScale =
        Object.values(chart.scales).find((s: any) => s?.axis === axis) ??
        (chart.scales as any)[axis]

      if (indexScale?.getPixelForValue) {
        pos = indexScale.getPixelForValue(active.index)
      }
    }

    if (typeof pos !== 'number') return

    ctx.save()
    ctx.beginPath()

    if (axis === 'x') {
      ctx.moveTo(pos, top)
      ctx.lineTo(pos, bottom)
    } else {
      ctx.moveTo(left, pos)
      ctx.lineTo(right, pos)
    }

    ctx.lineWidth = opts?.width ?? 1
    ctx.setLineDash(opts?.dash ?? [])
    ctx.strokeStyle = opts?.color ?? theme.palette.divider
    ctx.stroke()
    ctx.restore()
  }
}
